"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EstacaoColecao = void 0;
var bson_1 = require("bson");
var EstacaoColecao = /** @class */ (function () {
    function EstacaoColecao(_a) {
        var _b = _a._id, _id = _b === void 0 ? new bson_1.ObjectId() : _b, _c = _a.estacao, estacao = _c === void 0 ? '' : _c, _d = _a.colecao, colecao = _d === void 0 ? '' : _d;
        this._id = _id;
        this.estacao = estacao;
        this.colecao = colecao;
    }
    return EstacaoColecao;
}());
exports.EstacaoColecao = EstacaoColecao;
//# sourceMappingURL=EstacaoColecao.js.map